import { render, staticRenderFns } from "./CertidoesLogs.vue?vue&type=template&id=25b0912f"
import script from "./CertidoesLogs.vue?vue&type=script&lang=js"
export * from "./CertidoesLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports